import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export function DetailShell({ overline, title, subtitle, actions, backTo, testId, children }) {
  const nav = useNavigate();
  return (
    <div data-testid={testId}>
      <button
        data-testid="detail-back"
        onClick={() => (backTo ? nav(backTo) : nav(-1))}
        className="flex items-center gap-2 text-sm text-[#52525b] hover:text-[#09090b] mb-4 transition-colors"
      >
        <ArrowLeft size={16} weight="bold" /> Back
      </button>
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6 pb-6 border-b border-[#e4e4e7]">
        <div>
          {overline ? <div className="phizo-label mb-2">{overline}</div> : null}
          <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tighter text-[#09090b]">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-sm text-[#52525b] mt-2 max-w-2xl">{subtitle}</p>
          ) : null}
        </div>
        {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
      </div>
      {children}
    </div>
  );
}

export function InfoRow({ label, value, testId }) {
  return (
    <div className="border-b border-[#f4f4f5] py-2.5">
      <div className="phizo-label text-[10px] mb-0.5">{label}</div>
      <div className="text-sm font-medium text-[#09090b]" data-testid={testId}>
        {value ?? <span className="text-[#a1a1aa]">—</span>}
      </div>
    </div>
  );
}

export function InfoGrid({ children, cols = 2 }) {
  const colClass = cols === 3 ? "sm:grid-cols-3" : cols === 4 ? "sm:grid-cols-4" : "sm:grid-cols-2";
  return (
    <div className={`grid grid-cols-1 ${colClass} gap-x-6 gap-y-0 phizo-card p-4`}>{children}</div>
  );
}
